export enum EbookStatusEnum {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  PROCESS = 'Process',
  UNPUBLISHED = 'UNPUBLISHED',
}
